// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.ArrowES = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.ArrowES = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var ArrowES = _exports.ArrowES = function ArrowES(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M6.95895 14.5174C6.95895 14.3709 7.0182 14.2374 7.11454 14.1411C7.21089 14.0447 7.34386 13.985 7.49089 13.9855L13.2315 13.9855L5.10731 5.86133C4.89956 5.65358 4.89956 5.31637 5.10731 5.10863C5.31505 4.90088 5.65226 4.90088 5.86001 5.10863L13.9837 13.2323L13.9837 7.49172C13.9837 7.19767 14.222 6.95929 14.5161 6.9593C14.8102 6.9593 15.0485 7.19767 15.0485 7.49173L15.0485 14.517C15.0485 14.5862 15.0345 14.6553 15.0074 14.7206C14.9537 14.8505 14.8498 14.9544 14.7199 15.0081C14.6546 15.0352 14.5854 15.0494 14.5161 15.0494L7.4909 15.0494C7.19684 15.0494 6.95896 14.8115 6.95895 14.5174Z",
      fill: "#212B36"
    }));
  };
});
